export function isEqualsMetrics(m1, m2) {
  if (typeof m1 !== typeof m2) {
    return false;
  }

  if (m1.dataPointType !== m2.dataPointType) {
    return false;
  }

  if (m1.dataPoints.length !== m2.dataPoints.length) {
    return false;
  }

  for (let i = 0; i < m1.dataPoints.length; i += 1) {
    if (m1.dataPoints[i].value !== m2.dataPoints[i].value) {
      return false;
    }
  }

  return true;
}
